import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CollapseComponent } from './collapse/collapse.component';
import { CaptchaImageComponent } from './captcha-image/captcha-image.component';
import { GenericFormComponentsModule } from '../generic-form-components/generic-form-components.module';
import { SecureService } from 'idt-ecommerce-api/secure/secure.service';
import { TranslatePipeModule } from '../pipes/translate.pipe.module';
import { AnalyticsEventDirectiveModule } from 'idt-analytics-api/directives/analytics-events-directive.module';
import { TranslatePipe } from '../pipes/translate.pipe';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { RenderStorageScrollPosition } from 'render/render-storage/render-storage-scroll-position/render-storage-scroll-position';
import { DeviceInfoModule } from '../services/device-info/device-info.module';
import { BackButtonComponent } from './back-button/back-button.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    GenericFormComponentsModule,
    TranslatePipeModule,
    LazyLoadModule,
    AnalyticsEventDirectiveModule,
    DeviceInfoModule,
  ],
  exports: [
    CollapseComponent,
    CaptchaImageComponent,
    BackButtonComponent
  ],
  declarations: [
    CollapseComponent,
    CaptchaImageComponent,
    BackButtonComponent
  ],
  providers: [
    {
      provide: 'Document',
      useValue: document
    },
    {
      provide: 'Window',
      useValue: window
    },
    SecureService,
    TranslatePipe,
    RenderStorageScrollPosition
  ]
})
export class SharedComponentsModule {}
